<template>
  <div 
    class="deal-offer-wrap"
    v-if="showNudgeModal && Object.keys(getData).length > 0 && Object.keys(moduleData)?.length >0 "
  >
    <div
      class="deal-offer-container fs-11 lh16 flex-row pt8 pb8"
      :style="getModuleData?.nudgeStyle"
      :class="[
        {hide: Object.keys(getModuleData).length == 0},
        isMenu ? isBottomBarOpen ? 'bottom0' : 'aboveBottomBar' : '',
      ]"
      @click="handleNudgeClick"
    >
      <div class="flex-row ml16">
        <div 
          class="flex-column nudgeIcon mr8"
          :load-lottie="getNudgeLottieData(getModuleData?.cartAnimation)"
        >
          <VueLottiePlayer
            v-if="showModuleViaAccToPrioerity && getModuleData?.cartAnimation && showLottie"
            name="nudgeLottie"
            width="100%"
            height="100%"
            :loop="true"
            :animationData="getNudgeLottie"
          />
          <lazy-image v-else class="" :src="getModuleData?.icon" alt="banner image" loading="lazy"/>
        </div>
        <div class="flex-column">
          <span class="fs-12" v-html="getModuleData?.title"></span>
          <span class="fs-12" v-html="getSubtitle(getModuleData?.subTitle)"></span>
        </div>
      </div>
      <div class="mr10 hand-cursor" v-if="isNudgeClickable">
        <i class="jfi-arrow-line ml7"></i>
      </div>
    </div>

    <generic-modal
      v-if="showDealOfferModal"
      @close.stop="closeDealOfferModal"
      :width="modalDim.width"
      :height="modalDim.height"
      :modalClass="modalDim.modalClass"
      :bottom="modalDim.bottom"
      :animationStyle="modalDim.animationStyle"
      :modalStyle="getModuleData?.modalGradient"
    >
      <template v-slot:header></template>
      <template v-slot:body>
        <div class="flex-column">
          <div 
            class="deal-close-btn"
            @click="closeDealOfferModal"
          >
            <i 
              class="jfi-close-v2"
              :style="getModuleData?.crossColor"
            ></i>
          </div>
          <div v-if="showShimmer">
            <div 
              class="deal-shimmer flex-column"
              :style="getModuleData?.bannerSeparatorColor"
            >
              <div class="deal-shimmer-container"></div>
              <div class="deal-shimmer-container"></div>
              <div class="deal-shimmer-container"></div>
            </div>
            <div 
              class="deal-shimmer flex-column"
              :style="getModuleData?.bannerSeparatorColor"
            >
              <div class="deal-shimmer-container"></div>
              <div class="deal-shimmer-container"></div>
              <div class="deal-shimmer-container"></div>
            </div>
            <div class="deal-shimmer flex-column">
              <div class="deal-shimmer-container"></div>
            </div>
          </div>
          <div
            :class="{ hide: showShimmer }"
          >
            <div class="deal-top-banner">
              <lazy-image
                :src="getModuleData?.topBanner" 
                :style="getModuleData?.bannerSeparatorColor"
                :onload="updateShimmerFlag(false)"
                alt="banner image" 
              />
            </div>
            <div class="deal-bottom-banner">
              <lazy-image
                :src="getModuleData?.bottomBanner" 
                :style="getModuleData?.bannerSeparatorColor"
                :onload="updateShimmerFlag(false)"
                alt="banner image" 
              />
            </div>
            <div class="deal-offer-btn">
              <button 
                class="actionBtn fs-14"
                :style="getModuleData?.ctaStyle"
                @click="handleCtaClick(getModuleData?.btnAction)"
              >
                {{ getModuleData?.buttonLabel }}
              </button>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer></template>
    </generic-modal>

    <!-- Confetti -->
    <generic-modal
      v-if="showConfettiModal"
      @close="updateConfettiModalFlag(false)"
      :height="'auto'"
      :width="msModalDim.width"
      :modalClass="msModalDim.modalClass"
    >
      <template v-slot:header>
        <p></p>
      </template>
      <template v-slot:body>
        <div class="lottie-confetti">
          <VueLottiePlayer
            name="confettiAnim"
            width="100%"
            height="100%"
            :loop="true"
            :path="
              staticImgBaseUrl +
              '/images/animation/confetti.json'
            "
          />
        </div>
        <div class="lottie-offer-icon">
          <VueLottiePlayer
            name="offerIconAnim"
            width="100%"
            height="100%"
            :loop="true"
            :path="
              staticImgBaseUrl +
              '/images/animation/offer-icon-animation.json'
            "
          />
        </div>
        <div class="offer-applied-popup tc flex-column">
          <div class="fs-18 lh25 bold">
            {{ getModuleData?.confettiTitle }}
          </div>
          <div class="fs-18 lh25 bold">
            {{ getModuleData?.confettiSubTitle }}
          </div>
        </div>

      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>
<script>
import { keyMapsAction, keyMapsGetter, keyMapsMutation } from '../helpers/storeKeys';
import GenericModal from './GenericModal.vue';
import { defineAsyncComponent } from "vue";
import { 
  staticImgBaseUrl, 
  showIplNudgeModal,
  projectBasePathWithFolder,
  v2PwaBasePath,
  keyForStoreStressRegister,
  allowedPageForStoreStress,
  timeoutPerformanceForStoreSressApi
} from '../config/apiEndpoints';
import Utility from '../helpers/utility';
import LocalStorageFunc from '../helpers/localStorageFunc';
import PageNames from '../config/pageNames';
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";

export default {
  name: "DealOffer",
  props: ["moduleProps"],
  data() {
    return {
      modulePropsData: {},
      modalDim: {
        width: '100%',
        height: 'fit-content',
        modalClass: 'deal-offer-modal',
        animationStyle: "slide-up-stick-bottom",
        bottom: '0',
        left: '0'
      },
      moduleData: {},
      showConfettiModal: false,
      msModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout hide-vertical-scrollbar",
      },
      lottieConfetti: null,
      staticImgBaseUrl: staticImgBaseUrl,
      showShimmer: true,
      isNudgeClickable: false,
      currentCartMov : 0,
      showModuleViaAccToPrioerity: false,
      storeStressFlag: false,
    };
  },
  components: {
    GenericModal,
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    if(Utility.getLinkRewriteFromSiteprops().includes('home')) {
      let cartTotalFromLocalStorage = Number(localStorage['cartTotal'] || 0);
      this.$store.commit(
        keyMapsMutation.UPDATE_CART_TOTAL_FROM_LOCAL_STORAGE,
        cartTotalFromLocalStorage
      );
    }
    else {
      LocalStorageFunc.setLocalStorageValue('cartTotal', 0);
    }

    this.isNudgeClickable = this.modulePropsData?.isNudgeClickable == "true" || false;
    let pageName = Utility.getCurrentStoreFolder();
    if (pageName) {
      if (pageName.includes("menu")) {
        pageName = "menu";
      } else {
        pageName = "home";
      }
    }
    const storeStressFlag = allowedPageForStoreStress && allowedPageForStoreStress.includes(pageName);
    if(keyForStoreStressRegister && storeStressFlag && !this.storeStressFlag){
      setTimeout(()=> {
        this.$store.dispatch(keyMapsAction.GET_STORE_STRESS_DATA);
      }, timeoutPerformanceForStoreSressApi);
    }
    this.storeStressFlag = true;
  },
  computed: {
    cartTotal() {
      let cartTotal = Number(this.$store.getters[keyMapsGetter.CART_TOTAL]);
      let cartTotalFromLocalStorage = this.$store.state.Cart.cartTotalFromLocalStorage || 0;

      cartTotal += cartTotalFromLocalStorage;

      const isConfettiPlayed = LocalStorageFunc.getSessionStorageKey('confettiPlayed');
      if(cartTotal >= this.getCartMov && isConfettiPlayed !== true) {
        LocalStorageFunc.setSessionStorageKey('confettiPlayed', true);
        this.updateConfettiModalFlag(true);
        setTimeout(() => {
          this.updateConfettiModalFlag(false);
        }, 3000);
      }
      else if(cartTotal < this.getCartMov) {
        LocalStorageFunc.setSessionStorageKey('confettiPlayed', false);
      }
      return cartTotal;
    },
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    getModuleData() {
      const cartTotal = this.cartTotal;
      if(cartTotal == 0) {
        return this.moduleData["cartTotalZero"];
      }
      else if(cartTotal > 0 && cartTotal < this.getCartMov) {

        return this.moduleData["cartTotalPreMov"];
      }
      else {
        return this.moduleData["cartTotalPostMov"];
      }
    },
    getData() {
      return this.$store.state.User?.staticWidgetData || {};
      const {subType = ''} = this.modulePropsData;
      const tempData = this.$store.state.User?.staticWidgetData || {};
      const data = tempData?.[subType] || [];
      for(let i=0;i<data.length;i++) {
        const subType = data[i]?.subtype || "";
        this.moduleData[subType] = this.setModuleData(data[i]);
        if(i === 0 ){
          this.currentCartMov =  Number(this.moduleData[subType]?.cartMOV) || 350;
        }
      }

      if(Object.keys(this.moduleData) && this.showNudgeModal){
        this.$store.commit(keyMapsMutation.UPDATE_IS_BOTTOM_NUDGE_VISIBLE, true);
      }
      return this.moduleData;
    },
    showDealOfferModal() {
      return this.$store.state.DealOffer.showDealOfferModal;
    },
    isBottomBarOpen() {
      const pageName = Utility.getCurrentStoreFolder();
      return this.cartQuantity == 0 && pageName.includes("menu");
    },
    isMenu() {
      const pageName = Utility.getCurrentStoreFolder();
      return pageName.includes('menu');
    },
    isSeparateMenuVariant() {
      if (
        Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME ||
        Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST
      ) {
        return true;
      } else {
        return false;
      }
    },
    currentElementIdInStore() {
      return (
        this.$store.state.ProductItems.allCategoryId?.length !== undefined &&
        this.$store.state.ProductItems.allCategoryId
      );
    },
    isAnchorLinkVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL
      ) {
        return true;
      } else {
        return false;
      }
    },
    getNudgeLottie() {
      return this.$store.state.DealOffer.lottieJson;
    },
    showLottie() {
      return this.$store.state.DealOffer.showLottie;
    },
    getCartMov() {
      return this.currentCartMov;
    },
  },
  methods: {
    showNudgeModal() {
      return showIplNudgeModal;
    },
    setModuleData(data) {
      const {
        subType = '',
        icon = '',
        image1 = '',
        image2 = '',
        startColor = '',
        endColor = '',
        subTitle = '',
        title = '',
        props = {},
        cartAnimation = '',
        cartMOV = 0
      } = data;
      const {
        gradientStartColor = '',
        gradientEndColor = '',
        ctaTextColor = '',
        ctaBgColor = '',
        cta = '',
        confettiTitle = '',
        confettiSubTitle = '',
        popupCrossColor = '',
        separatorColor = '',
        nudgeBackgroundImage = ''
      } = props;
      const btnObject = JSON.parse(cta);
      const btnAction = btnObject?.links && btnObject.links.length > 0 ? btnObject.links[0] : {};
      const nudgeBackgroundImageStyle = nudgeBackgroundImage ? `
          background-image: url('${nudgeBackgroundImage}');
          background-repeat: no-repeat;
          background-size: cover;
        ` : '';

      return {
        title,
        subTitle,
        subType,
        nudgeStyle: nudgeBackgroundImageStyle ? nudgeBackgroundImageStyle : `background-image: linear-gradient(to right, ${startColor} , ${endColor});`,
        icon,
        modalGradient: `background-image: linear-gradient(40deg, ${gradientStartColor} , ${gradientEndColor});`,
        topBanner: image1,
        bottomBanner: image2,
        bannerSeparatorColor: `border-bottom: 1px solid ${separatorColor};`,
        crossColor: `color: ${popupCrossColor};`,
        buttonLabel: btnObject?.label || '',
        btnAction,
        ctaStyle: `background-color: ${ctaBgColor}; color: ${ctaTextColor}`,
        confettiTitle,
        confettiSubTitle,
        cartAnimation,
        cartMOV
      };
    },
    getNudgePrice() {
      return (this.getCartMov - this.cartTotal).toFixed(0);
    },
    getSubtitle(subTitle) {
      return subTitle.replace("<price>", this.getNudgePrice());
    },
    handleNudgeClick() {
      if(!this.isNudgeClickable){
        return;
      }
      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_DEAL_OFFER_MODAL_FLAG, true);
    },
    closeDealOfferModal() {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_DEAL_OFFER_MODAL_FLAG, false);
    },
    handleCtaClick(data) {
      // event needs to be added
      this.closeDealOfferModal();
      this.scrollOrRedirectCategory(data);
    },
    updateConfettiModalFlag(flag) {
      flag ? document.body.classList.add("body-stop-scroll-mobile") : document.body.classList.remove("body-stop-scroll-mobile");
      this.showConfettiModal = flag;
      this.updateShimmerFlag(true);
    },
    updateShimmerFlag(flag) {
      setTimeout(() => {
        this.showShimmer = flag;
      }, 1000);
    },
    scrollOrRedirectCategory(data) {
      const action = this.getData?.action;
      const href = data?.href || '9999';

      if(this.isSeparateMenuVariant) {
        let url =
            projectBasePathWithFolder +
            Utility.getMenuCategory() +
            LocalStorageFunc.storeId() +
            Utility.getUrlQueryString();
        if (
          action === "menu" ||
          action === "MENU_LIST" ||
          action === "PRODUCT_LIST"
        ) {
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", href);
          window.location.href = url;
        } 
        else if (action === "edv") {
          const hrefIs = href;
          if(hrefIs == '7'){
            window.location.href = `${v2PwaBasePath}/${action}?type=199`;
          }
          else if(hrefIs == '6'){
            window.location.href = `${v2PwaBasePath}/${action}?type=99`;
          } 
          else{
            window.location.href = `${v2PwaBasePath}/${action}`;
          }
        } 
        else if (
          action === "edvitems" ||
          action === "edvList" ||
          action === "offers"
        ) {
          window.location.href = `${v2PwaBasePath}/${action}`;
        } 
        else if (action === "gamifyWebview" || action === "redirect") {
          window.location.href = `${v2PwaBasePath}/${href}`;
        } 
        else {
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
          window.location.href = url;
        }
        return;
      }

      let currentElem = this.currentElementIdInStore.map((i) => i.categoryId);
      let curElementId = currentElem.includes(Number(href));
      if (curElementId) {
        let scrollTopMargin = 70;//default
        if(this.isAnchorLinkVariant){
          scrollTopMargin = window.screen.width <= 321 ? 70 : 102;
        }
        switch (action) {
          case "menu":
            Utility.scrollUptoTo("element_catg_" + href ,scrollTopMargin);
            break;
          case "MENU_LIST":
            Utility.scrollUptoTo("element_catg_" + href , scrollTopMargin);
            break;
          case "PRODUCT_LIST":
            Utility.scrollUptoTo("element_catg_" + href , scrollTopMargin);
            break;
          default: // set the default scroll to home
            Utility.scrollUptoMenuTop();
            break;
        }
      } else {
        if(action === "edv"){
          const hrefIs = href;
          if(hrefIs == '7'){
            window.location.href = `${v2PwaBasePath}/${action}?type=199`;
          }
          else if(hrefIs == '6'){
            window.location.href = `${v2PwaBasePath}/${action}?type=99`;
          } else{
            window.location.href = `${v2PwaBasePath}/${action}`;
          }
        }
        else if (
          action === "edvitems" ||
          action === "edvList" ||
          action === "offers"
        ) {
          window.location.href = `${v2PwaBasePath}/${action}`;
        } else if (action === "gamifyWebview" || action === "redirect") {
          window.location.href = `${v2PwaBasePath}/${href}`;
        } else {
          Utility.scrollUptoMenuTop();
        }
      }
    },
    getNudgeLottieData(lottieUrl) {
      if(!this.showLottie) {
        this.$store.dispatch(keyMapsAction.GET_LOTTIE_JSON, lottieUrl);
      }
    },
  },
  watch: {
    getData: {
      handler(newVal, oldVal) {
        setTimeout(()=>{
          const {subType = ''} = this.modulePropsData;
          const tempData = newVal || {};
          const data = tempData?.[subType] || [];
          for(let i=0;i<data.length;i++) {
            const subType = data[i]?.subtype || "";
            this.moduleData[subType] = this.setModuleData(data[i]);
            if(i === 0 ){
              this.currentCartMov =  Number(this.moduleData[subType]?.cartMOV) || 350;
            }
          }

          if(Object.keys(this.moduleData) && this.showNudgeModal){
            this.$store.commit(keyMapsMutation.UPDATE_IS_BOTTOM_NUDGE_VISIBLE, true);
          }
          setTimeout(()=>{
            this.showModuleViaAccToPrioerity = true;
          }, 2000);
        }, 500);
      }
    }
  }
};
</script>

<style></style>
